// features/public-filters/domain/mappers/bathMapper.ts
import { Range } from '../FilterTypes';
import { bathValueMap } from '../filterOptions';

export type BathOptionLabel = 'any' | '1+' | '1.5+' | '2+' | '2.5+' | '3+' | '4+';

/**
 * Baths are "min only" in your UX.
 * any → unbounded; N+ → [N, ∞)
 */
export function applyBathsClick(option: BathOptionLabel): Range {
  if (option === 'any') {
    return Range.create(null, null);
  }

  const value = bathValueMap[option];
  return Range.create(value, null);
}

export function isBathOptionSelected(
  option: BathOptionLabel,
  range: Range | null,
  index: number,
): boolean {
  if (!range || range.min == null) {
    return index === 0; // "any"
  }

  if (option === 'any') return false;

  const value = bathValueMap[option];
  return range.min === value;
}
